import { gql } from "@apollo/client"

const SENSOR_RULE_FIELDS = gql`
  fragment SensorRuleFields on SensorRule {
    id
    integration
    name
    enabled
    triggered
    lastTriggeredAt
    lastNotifiedAt
    triggeredCount
    triggers {
      id
      type
      originalId
      unit
      conditions {
        value
        operator
      }
      triggersCombination
    }
    notifications {
      id
      contact
      methods
    }
    notificationDelay {
      consecutiveTriggerCount
    }
    category
  }
`

export { SENSOR_RULE_FIELDS }
